import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Project';

const routes = [
    {
        matchRegex: '/ProjectQuote',
        name: getRouteName(MODULE_NAME, 'Quote'),
        slots: [SLOT_KEY.SLOT_ADDITION_MENU],
        image: PreviewDListlImg,
    },
    {
        matchRegex: '/ProjectQuote/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Quote Detail'),
        slots: [SLOT_KEY.SLOT_ADDITION_MENU, SLOT_KEY.SLOT_TAB, SLOT_KEY.SLOT_V_TABLE_COLUMN,],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
            ],
        }
    },
    {
        matchRegex: '/ProjectInvoice/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Invoice Detail'),
        slots: [SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
    },
    {
        matchRegex: '/ProjectCredit/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Credit Detail'),
        slots: [SLOT_KEY.SLOT_V_TABLE_COLUMN, SLOT_KEY.SLOT_SCRIPTS],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
    },
    {
        matchRegex: '/Project',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [SLOT_KEY.SLOT_V_SECTION],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [{ key: 'page-additional-menu-action', label: 'Page Additional Menu Action' }]
        }
    },
    {
        matchRegex: '/Project/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [SLOT_KEY.SLOT_ADDITION_MENU, SLOT_KEY.SLOT_TAB, SLOT_KEY.SLOT_SECTION],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'section-search-job-filter', label: 'Advanced Search Filter' },
            ],
        },
    },

]

export default routes;
